import WFSettings from '../../data/platform/workflow_settings.json';
import { PROVIDER_XERO, PROVIDER_OUTLOOK, PROVIDER_GOOGLE_DRIVE, PROVIDER_GOOGLE_SHEETS } from '../../constants';

export const filterVotesData = (userId, votesData, combinationsData) => {
  return combinationsData.map((combination) => {
    // get this users vote
    const my_vote =
      votesData.filter((vote) => {
        if (vote.combination_id === combination.id && vote.user_id === userId) return true;
      }).length > 0;

    const votes = votesData.filter((vote) => vote.combination_id === combination.id).length;
    return { ...combination, votes, my_vote };
  });
};

export const authorizeCombo = (updatedCombinationsData, activeConnections) => {
  updatedCombinationsData.forEach((combo) => {
    let cons_filtered = [];

    // check if the provider is Xero
    if (WFSettings.connectors_comboIDs.xero.includes(combo.id)) {
      cons_filtered = activeConnections.filter(
        (connection) => connection.provider === PROVIDER_XERO && connection.authorization_status === 'success',
      );
      if (cons_filtered.length > 0) {
        combo.authed = true;
      } else {
        combo.authed = false;
      }
    } else if (WFSettings.connectors_comboIDs.outlook.includes(combo.id)) {
      // Outlook
      cons_filtered = activeConnections.filter(
        (connection) => connection.provider === PROVIDER_OUTLOOK && connection.authorization_status === 'success',
      );
      if (cons_filtered.length > 0) {
        combo.authed = true;
      } else {
        combo.authed = false;
      }
    } else if (WFSettings.connectors_comboIDs.google_drive.includes(combo.id)) {
      // G drive
      cons_filtered = activeConnections.filter(
        (connection) => connection.provider === PROVIDER_GOOGLE_DRIVE && connection.authorization_status === 'success',
      );
      if (cons_filtered.length > 0) {
        combo.authed = true;
      } else {
        combo.authed = false;
      }
    } else if (WFSettings.connectors_comboIDs.google_sheets.includes(combo.id)) {
      // G sheets
      cons_filtered = activeConnections.filter(
        (connection) => connection.provider === PROVIDER_GOOGLE_SHEETS && connection.authorization_status === 'success',
      );
      if (cons_filtered.length > 0) {
        combo.authed = true;
      } else {
        combo.authed = false;
      }
    } else if (combo.id === 8 || combo.id === 10 || combo.id === 11) {
      combo.authed = true;
    }
  });
  return updatedCombinationsData;
};
